import * as z from "zod";

export const bulkAddTopicsToPrompts = {
  name: "bulkAddTopicsToPrompts" as const,
  input: z.object({
    promptIds: z.array(z.bigint()),
    topicIds: z.array(z.bigint()),
  }),
  output: z.object({}),
};
